import { render, staticRenderFns } from "./facturation_traiter.vue?vue&type=template&id=480781e2&scoped=true&"
import script from "./facturation_traiter.vue?vue&type=script&lang=js&"
export * from "./facturation_traiter.vue?vue&type=script&lang=js&"
import style0 from "./facturation_traiter.vue?vue&type=style&index=0&id=480781e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480781e2",
  null
  
)

export default component.exports